<template>
    <div class="pa-3" :style="$vuetify.display.mobile ? 'width: 100%' : ''">
        <template v-if="isAuthorized">
            <v-row
                v-if="auditCheckKey === undefined"
                id="documents-filter-box"
                class="mb-2"
                :key="reloadData"
                no-gutters
            >
                <v-col cols="1">
                    <v-btn-primary
                        block
                        v-if="
                            (currentUser.profile.configuration.expenseReport.write ||
                                currentUser.profile.configuration.expenseReport.writeOnlySelf) &&
                            !$vuetify.display.mobile
                        "
                        @click="onNewExpenseReport()"
                        data-cy="expenseReports-create"
                        id="Add"
                        size="large"
                    >
                        Ajouter
                    </v-btn-primary>
                </v-col>
                <template v-if="auditCheckKey === undefined">
                    <v-col cols="2" v-if="!$vuetify.display.mobile" class="px-1" id="Interval">
                        <v-row
                            style="background-color: #fff; border-radius: 15px"
                            class="mx-1"
                            no-gutters
                        >
                            <v-col>
                                <oss-text-field
                                    v-model="minAmount"
                                    :label="'Min'"
                                    color="secondary"
                                    :min="'0'"
                                    :type="'string'"
                                    hide-details
                                    data-cy="ExpenseReports-min"
                                />
                            </v-col>
                            <v-col cols="1" class="d-flex align-center justify-center">
                                <v-icon>$oss-chevron-left</v-icon>
                            </v-col>
                            <v-col>
                                <oss-text-field
                                    v-model="maxAmount"
                                    :label="'Max'"
                                    :color="'secondary'"
                                    :min="'0'"
                                    :type="'string'"
                                    hide-details
                                    data-cy="ExpenseReports-max"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="2" v-if="!$vuetify.display.mobile" class="px-1" id="Statut">
                        <v-select
                            outlined
                            label="Statut note de frais"
                            v-model="status"
                            :items="
                                allExpenseStatus.map((status) => ({
                                    value: status,
                                    text: getStatusFormat(status),
                                }))
                            "
                            :hide-details="true"
                            item-value="value"
                            data-cy="ExpenseReports-statut"
                            density="compact"
                            :item-title="(item) => item.text"
                        />
                    </v-col>
                    <v-col cols="2" v-if="!$vuetify.display.mobile" class="px-1" id="Date">
                        <oss-date-range-picker
                            :begin="beginDate"
                            :end="endDate"
                            hide-details
                            dense
                            @change-date-range="onDateRangeChanged"
                            prefixDataCy="ExpenseReports"
                        />
                    </v-col>
                    <v-col
                        :cols="$vuetify.display.mobile ? '11' : '2'"
                        :class="$vuetify.display.mobile ? 'pb-2' : 'px-1'"
                        id="Search"
                    >
                        <v-text-field
                            outlined
                            v-model="search"
                            append-inner-icon="$fa-search"
                            clearable
                            @click:clear="search = ''"
                            label="Recherche"
                            :hide-details="true"
                            data-cy="ExpendReports-search"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="1" v-if="!$vuetify.display.mobile" class="px-1" id="Delete">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    medium
                                    text
                                    @click="clearFilter()"
                                    class="btn-filter"
                                    data-cy="ExpenseReports-refreshFilters"
                                    v-bind="props"
                                >
                                    <v-icon medium>$delete</v-icon>
                                </v-btn-icon>
                            </template>
                            <span>Réinitialiser les filtres</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="1" v-if="!$vuetify.display.mobile">
                        <TutorialButtonDialog :starterComponents="'ExpenseReports;'">
                        </TutorialButtonDialog>
                    </v-col>

                    <v-col
                        class="d-flex justify-end px-1"
                        cols="4"
                        v-if="!$vuetify.display.mobile && auditCheckKey !== undefined"
                    >
                        <v-switch
                            v-model="isIgnored"
                            :label="'Filtrer les alertes ignorés'"
                            style="text-center"
                        />
                    </v-col>
                </template>
                <template v-else>
                    <v-col class="d-flex justify-end" cols="4" v-if="!$vuetify.display.mobile">
                        <v-switch
                            v-model="isIgnored"
                            hide-details
                            label="Filtrer les alertes ignorés"
                            style="text-center"
                        />
                    </v-col>
                </template>
            </v-row>
            <v-row no-gutters id="Details">
                <v-col cols="12">
                    <oss-data-table
                        v-model="expenseReportsSelected"
                        :headers="headers"
                        :items="items"
                        :page="pagination.page"
                        :sortBy="pagination.sortBy"
                        :sortDesc="pagination.descending"
                        :items-per-page="pagination.rowsPerPage"
                        :items-length="pagination.totalItems"
                        :loading="loading"
                        :table-hover="true"
                        hide-default-header
                        :dense="true"
                        :striped="true"
                        :show-select="true"
                        hide-default-footer
                        fixed-header
                        v-if="!$vuetify.display.mobile"
                        @clickRow="openExpenseReport($event.id)"
                        @load-more="loadMore()"
                        prefixCy="ExpenseReports"
                    >
                        <template v-slot:no-data>
                            <v-row no-gutters class="py-3" @click="onNewExpenseReport()">
                                <v-col cols="12" class="d-flex justify-center">
                                    Aucune note de frais déclarée
                                </v-col>
                                <v-col cols="12" class="py-3 d-flex justify-center">
                                    <v-btn-add
                                        v-if="
                                            currentUser.profile.configuration.expenseReport.write ||
                                            currentUser.profile.configuration.expenseReport
                                                .writeOnlySelf
                                        "
                                    ></v-btn-add>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:menu="{ item, close }">
                            <v-list>
                                <v-list-item
                                    v-if="auditCheckKey && item.auditCheckStatus !== 'IGNORE'"
                                    @click.stop="
                                        ignoreCheck(item);
                                        close();
                                    "
                                >
                                    <v-list-item-title>Ignorer</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="auditCheckKey && item.auditCheckStatus === 'IGNORE'"
                                    @click.stop="
                                        ignoreCheck(item);
                                        close();
                                    "
                                >
                                    <v-list-item-title>Rétablir</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click.stop="
                                        deleteLoading = false;
                                        toDeleteExpenseReportId = item.id;
                                        deleteDialog = true;
                                        close();
                                    "
                                >
                                    <v-list-item-title>Supprimer</v-list-item-title>
                                    <template v-slot:append>
                                        <v-icon size="small">$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </template>
                        <template v-slot:item.name="{ item }">
                            {{ item.name }}
                            {{ item.auditCheckStatus === "IGNORE" ? "( ignoré )" : "" }}
                            <v-icon
                                color="secondary"
                                v-if="item.uniqueExport && item.uniqueExport.id"
                                size="small"
                                location="end"
                                >$oss-already-downloaded</v-icon
                            >
                        </template>
                        <template v-slot:item.amount="{ item }">
                            {{ newCommonFormatCurrency(-item.amount, undefined) }}
                        </template>
                        <template v-slot:item.user="{ item }">
                            {{ getUserDisplayName(item) }}
                        </template>
                        <template v-slot:item.date="{ item }">
                            {{ getDateFormated(item) }}
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip size="small" variant="flat" color="#ffd983">
                                <v-icon left size="small">$label</v-icon>
                                <div class="pl-1">
                                    {{ getStatusFormat(item.status) }}
                                </div>
                            </v-chip>
                        </template>
                        <template v-slot:sum.amount="{ sum }">
                            {{ sum ? "-" + newCommonFormatCurrency(sum, undefined) : "" }}
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn-trash
                                v-if="!auditCheckKey"
                                @click.stop="
                                    deleteLoading = false;
                                    toDeleteExpenseReportId = item.id;
                                    deleteDialog = true;
                                "
                                size="small"
                            />
                            <v-btn
                                :hide-details="true"
                                :outlined="true"
                                rounded
                                @click.stop="ignoreCheck(item)"
                                v-if="auditCheckKey && item.auditCheckStatus !== 'IGNORE'"
                                class="elevation-0 mt-1"
                                size="small"
                            >
                                Ignorer
                            </v-btn>
                            <v-btn
                                :hide-details="true"
                                :outlined="true"
                                rounded
                                @click.stop="ignoreCheck(item)"
                                v-if="auditCheckKey && item.auditCheckStatus === 'IGNORE'"
                                class="elevation-0 mt-1"
                                size="small"
                            >
                                Rétablir
                            </v-btn>
                        </template>
                    </oss-data-table>

                    <v-row no-gutters v-else class="w-100">
                        <v-col cols="12" v-for="item in items" :key="item.id" class="py-1">
                            <!-- <swipe-out>
                                <template v-slot:right>
                                    <div
                                        class="swipeout-action red d-flex align-center px-6"
                                        title="remove"
                                        @click="
                                            deleteLoading = false;
                                            toDeleteExpenseReportId = item.id;
                                            deleteDialog = true;
                                        "
                                    >
                                        <v-icon color="#FFF" size="small">$oss-trash</v-icon>
                                    </div>
                                </template> -->
                            <v-card
                                elevation="0"
                                class="pa-2"
                                style="border-radius: 8px"
                                @click.stop="openExpenseReport(item.id)"
                            >
                                <v-row no-gutters style="flex-wrap: nowrap">
                                    <v-col
                                        style="
                                            overflow: hidden;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                        "
                                        class="flex-grow-1 flex-shrink-0"
                                        cols="8"
                                    >
                                        {{ item.name }}
                                        {{ item.auditCheckStatus === "IGNORE" ? "( ignoré )" : "" }}
                                    </v-col>
                                    <v-col
                                        style="
                                            overflow: hidden;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                        "
                                        class="flex-grow-1 flex-shrink-1 d-flex justify-end"
                                        cols="4"
                                    >
                                        <v-icon color="secondary" size="small" location="start"
                                            >$oss-calendar</v-icon
                                        >
                                        {{ getDateFormated(item) }}
                                    </v-col>
                                </v-row>
                                <v-row no-gutters style="flex-wrap: nowrap">
                                    <v-col
                                        style="
                                            min-width: 100px;
                                            max-width: 100%;
                                            overflow: hidden;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                        "
                                        class="flex-grow-1 flex-shrink-1"
                                    >
                                        <v-icon size="small" color="secondary" left>$fa-user</v-icon
                                        >{{ formatUser(item.user) }}
                                    </v-col>
                                    <v-col
                                        class="flex-grow-1 flex-shrink-1 d-flex justify-end align-center"
                                    >
                                        <v-icon left color="secondary" size="small">$label</v-icon
                                        >{{ getStatusFormat(item.status) }}
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!-- </swipe-out> -->
                        </v-col>
                    </v-row>
                    <oss-dialog
                        v-model="deleteDialog"
                        title="Supprimer cette note de frais ?"
                        @close="closeDelete"
                        @valid="deleteExpenseReport"
                        :validLoading="deleteLoading"
                        width="60vw"
                    >
                        <h4>{{ deleteText }}</h4>
                    </oss-dialog>
                    <DocumentWizardDialog
                        ref="documentWizardDialog"
                        v-if="newExpenseReport"
                        v-model="newExpenseReport"
                        :showFirstPrevious="false"
                        :companyId="companyId"
                        :inGlobalStep="'expenseReport'"
                        :openCameraOnly="openCameraOnly"
                        @created="onExpenseReportCreated"
                    />
                    <v-btn-add-icon
                        v-model="fab"
                        style="
                            position: fixed;
                            bottom: 60px;
                            right: 60px;
                            box-shadow: 10px 10px 7px rgba(0, 0, 0, 0.06);
                        "
                        v-if="$vuetify.display.mobile"
                        @click="onNewExpenseReport()"
                    >
                    </v-btn-add-icon>
                </v-col>
            </v-row>
        </template>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { State2Way } from "@/decorators";
import { User } from "../../store/store";

import { SwipeList, SwipeOut } from "vue-swipe-actions";
import { Apollo } from "@/decorators";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import EXPENSES_CHECK from "../../graphql/audit/AuditItems.gql";

import DELETE_EXPENSE_REPORT from "../../graphql/DeleteExpenseReport.gql";
import DELETE_MANY_EXPENSE_REPORTS from "../../graphql/DeleteManyExpenseReports.gql";
import EXPENSEREPORTS_FILTER_QUERY from "../../graphql/FilterExpenseReports.gql";
import UPSERT_AUDITCHECKRESULT_MUTATION from "../../graphql/audit/UpsertAuditCheckResultMutation.gql";
import DELETE_AUDITCHECKRESULT_MUTATION from "../../graphql/audit/DeleteAuditCheckResult.gql";

import DocumentWizardDialog from "../document/DocumentWizardDialog.vue";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import ChatList from "../chat/ChatList.vue";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../../services/dateServices";
import { checkAccessRights } from "../../services/accessRightServices";

import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import emitter from "@/services/emitter";

@Component({
    components: {
        ChatList,
        DocumentWizardDialog,
        SwipeOut,
        SwipeList,
        OssDataTable,
        TutorialButtonDialog,
    },
})
export class ExpenseReports extends Vue {
    newExpenseReport: boolean = false;
    reloadData = 0;
    isIgnored = true;

    toDeleteExpenseReportId = "";
    deleteLoading = false;
    deleteDialog = false;

    expenseReportsSelected = [];

    // automaticUpload = false

    openCameraOnly = false;

    fab = false;

    headers = [
        { text: "Nom", value: "name", align: "start", sortable: true },
        { text: "Personne", value: "user", align: "start" },
        { text: "Date", value: "date", align: "center", sortable: true },
        { text: "Montant", value: "amount", align: "end", sortable: true, sum: true },
        { text: "Statut", value: "status", align: "end", sortable: true },
        // { text: "", value: "action", align: "center" },
    ];

    onNewExpenseReport() {
        // this.automaticUpload = false
        this.openCameraOnly = false;
        this.newExpenseReport = true;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "expenseReport", "read");
        return authorized;
    }

    onOpenPhotoCamera() {
        // this.automaticUpload = true
        this.openCameraOnly = true;
        this.newExpenseReport = true;
    }

    get companyId() {
        return this.$route.params.companyId || this.$store.state.selected_company.id;
    }

    get orderBy() {
        if (this.pagination.sortBy.length) {
            return (
                this.pagination.sortBy[0] + "_" + (this.pagination.descending[0] ? "DESC" : "ASC")
            );
        }
        return null;
    }

    getDateFormated(expenseReport) {
        const date = expenseReport.date || expenseReport.dateAuto;
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
        return "";
    }

    getDateFormatedMobile(expenseReport) {
        const date = expenseReport.date || expenseReport.dateAuto;
        if (date) {
            return moment(date).format("DD MMMM");
        }
        return "";
    }

    onDateRangeChanged(data) {
        debugger;
        this.beginDate = data.begin;
        this.endDate = data.end;
    }

    getStatusFormat(status) {
        if (status === "") return "Tous";
        if (status === "EDITION") return "En édition";
        if (status === "PENDING_DOCUMENTS_VALIDATION") return "Trait. des documents";
        if (status === "PENDING_VALIDATION") return "En attente de validation";
        if (status === "VALIDATED") return "Validée";
        if (status === "INFORMATION_REQUEST") return "Remboursée";
        if (status === "DENIED") return "Refusée";
        if (status === "DELETED") return "Supprimée";
        return null;
    }

    get allExpenseStatus() {
        const allStatus = [
            "",
            "EDITION",
            "PENDING_DOCUMENTS_VALIDATION",
            "PENDING_VALIDATION",
            "VALIDATED",
            "DENIED",
            "INFORMATION_REQUEST",
        ];
        return allStatus;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get auditCheckKey() {
        return this.$route.params.auditCheckKey;
    }

    getUserDisplayName(item) {
        let name = "";
        if (item.user) {
            if (item.user.firstname) {
                name = item.user.firstname;
            }
            if (item.user.lastname) {
                if (name) {
                    name += " ";
                }
                name += item.user.lastname;
            }
        }
        if (!name) {
            name = "-";
        }
        return name;
    }

    // Ignorer l'erreur sur la note de frais
    //
    // audit check
    //
    async ignoreCheck(item) {
        const keyACR = this.auditCheckKey + "_" + item.id;
        if (!item.auditCheckStatus || item.auditCheckStatus !== "IGNORE") {
            if (this.auditCheckKey !== undefined) {
                const result = await this.$apollo.mutate({
                    mutation: UPSERT_AUDITCHECKRESULT_MUTATION,
                    variables: {
                        key: keyACR,
                        expenseReport: { connect: { id: item.id } },
                        auditCheckKey: this.auditCheckKey,
                        status: "IGNORE",
                        company: item.company.id,
                    },
                });
                item.auditCheckStatus = "IGNORE";
            }
        } else {
            const result = await this.$apollo.mutate({
                mutation: DELETE_AUDITCHECKRESULT_MUTATION,
                variables: {
                    key: keyACR,
                },
            });
            delete item.auditCheckStatus;
        }
    }

    get nextPageDisabled() {
        return (
            Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) <=
            this.pagination.page
        );
    }

    get deleteText() {
        if (this.expenseReportsSelected.length > 1) {
            return "Êtes-vous sûr(e) de vouloir supprimer cette note de frais ?";
        }
        let expenseReportIds = this.expenseReportsSelected.map((expenseReport) => expenseReport.id);
        if (expenseReportIds.includes(this.toDeleteExpenseReportId)) {
            return `Êtes-vous sûr(e) de vouloir supprimer ${expenseReportIds.length} notes de frais ?`;
        }
    }

    openExpenseReport(id: string) {
        this.$router.push({
            name: "expenseReport",
            params: {
                companyId: this.companyId,
                id: id,
            },
        });
    }

    onExpenseReportCreated() {
        this.newExpenseReport = false;
        if (this.$apollo.queries.dbItems) {
            this.clearFilter();
            this.dbItems = [];
            this.pagination.rowsPerPage = 50;
            this.pagination.page = 1;
            debugger;
            this.$apollo.queries.dbItems.refetch();
        }
    }

    clearFilter() {
        this.minAmount = "";
        this.maxAmount = "";
        this.status = "";
        this.beginDate = "";
        this.endDate = "";
        this.search = "";
        this.pagination.rowsPerPage = 50;
        this.pagination.page = 1;
    }

    // Filters stored in store
    @State2Way("updateExpenseReportsBeginDate", "expenseReportsFilter.date.begin")
    beginDate!: string;

    @State2Way("updateExpenseReportsEndDate", "expenseReportsFilter.date.end")
    endDate!: string;

    @State2Way("updateExpenseReportsMinAmount", "expenseReportsFilter.amount.minimum")
    minAmount!: string;

    @State2Way("updateExpenseReportsMaxAmount", "expenseReportsFilter.amount.maximum")
    maxAmount!: string;

    @State2Way("updateExpenseReportsStatus", "expenseReportsFilter.status")
    status!: string;

    @State2Way("updateExpenseReportsSearch", "expenseReportsFilter.search")
    search!: string;

    @State2Way("updateAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    @State2Way("updateExpenseReportsPagination", "expenseReportsFilter.pagination")
    pagination!: any;

    beforeMount() {
        this.pagination.rowsPerPage = 50;
        this.pagination.page = 1;
        this.pagination.sortBy = ["date"];
        this.pagination.descending = ["desc"];
        this.onAccountingPeriodChanged(this.selectedAccountingPeriod, undefined);
        emitter.$on("launchTuto", this.startTuto);
    }

    @Watch("selectedAccountingPeriod")
    onAccountingPeriodChanged(value, prevValue) {
        if (value) {
            if (!this.beginDate) {
                this.beginDate = moment(value.start).format("YYYY-MM-DD");
            } else {
                const mBegin = moment(this.beginDate);
                if (mBegin.isBefore(moment(value.start)) || mBegin.isAfter(moment(value.end))) {
                    this.beginDate = moment(value.start).format("YYYY-MM-DD");
                }
            }
            if (!this.endDate) {
                this.endDate = moment(value.end).format("YYYY-MM-DD");
            } else {
                const mEnd = moment(this.endDate);
                if (mEnd.isAfter(moment(value.end)) || mEnd.isBefore(moment(value.start))) {
                    this.endDate = moment(value.end).format("YYYY-MM-DD");
                }
            }
        }
    }

    loading = false;

    // @Watch("loading")
    // onLoadingChanged(value, prevValue) {
    //     debugger;
    //     console.log("loading", value, prevValue);
    // }

    @Apollo({
        query: EXPENSES_CHECK,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.auditCheckKey,
                isIgnored: this.isIgnored,
            };
        },
        skip() {
            return !this.isAuthorized || !this.auditCheckKey;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.checkItems = data.auditItems.items;
                    this.pagination.totalItems = this.checkItems.length;
                    this.clearFilter();
                    this.reloadData++;
                }
            }
        },
    })
    checkItems: Array<any> = [];

    // FIXME: after deleting a an expense, and scrolling the table to the end, the query is fetched again but returns an empty list
    @Apollo({
        query: EXPENSEREPORTS_FILTER_QUERY,
        variables() {
            this.loading = true;
            debugger;
            return {
                minAmount: this.minAmount > 0 ? parseFloat(this.minAmount) : undefined,
                maxAmount: this.maxAmount > 0 ? parseFloat(this.maxAmount) : undefined,
                status: this.status.length > 0 ? this.status : undefined,
                beginDate: getDBFormattedStartDate(this.beginDate),
                endDate: getDBFormattedEndDate(this.endDate),
                search: this.search.length > 0 ? this.search : undefined,
                companyId: this.companyId,
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                orderBy: this.orderBy,
            };
        },
        fetchPolicy: "network-only",
        debounce: 500,
        skip() {
            return !this.isAuthorized || this.auditCheckKey !== undefined;
        },
        specificResult({ data, loading, networkStatus }: any) {
            // debugger
            if (!loading && data) {
                // debugger
                this.dbItems = [...data.expenseReports];
                this.pagination.totalItems = data.expenseReportsConnection.aggregate.count;
                this.loading = false;
            }
        },
    })
    dbItems: any[] = [];

    get items() {
        if (this.auditCheckKey) {
            return this.checkItems;
        }
        return this.dbItems;
    }

    set items(value) {
        if (this.auditCheckKey) {
            this.checkItems = value;
        } else {
            this.dbItems = value;
        }
    }

    closeDelete() {
        this.deleteDialog = false;
        this.deleteLoading = false;
        this.toDeleteExpenseReportId = "";
    }

    formatUser(user) {
        if (!user) {
            return "";
        }
        return user.firstname + " " + user.lastname;
    }

    async deleteExpenseReport() {
        const expenseReportIds = this.expenseReportsSelected.map(
            (expenseReport) => expenseReport.id,
        );
        debugger;

        if (
            (!this.expenseReportsSelected.length && this.toDeleteExpenseReportId) ||
            !expenseReportIds.includes(this.toDeleteExpenseReportId)
        ) {
            const index = this.items.findIndex((x) => x.id === this.toDeleteExpenseReportId);
            if (index !== -1) {
                this.items.splice(index, 1);
            }
            await this.$apollo.mutate({
                mutation: DELETE_EXPENSE_REPORT,
                variables: {
                    id: this.toDeleteExpenseReportId,
                },
            });
            return this.closeDelete();
        }

        if (this.expenseReportsSelected.length) {
            await this.$apollo.mutate({
                mutation: DELETE_MANY_EXPENSE_REPORTS,
                variables: {
                    ids: this.expenseReportsSelected.map((er) => er.id),
                },
            });
            this.items = this.items.filter(
                (er) => !this.expenseReportsSelected.find((er2) => er2.id === er.id),
            );
            this.expenseReportsSelected = [];
            return this.closeDelete();
        }
    }

    loadMore() {
        if (this.items.length < this.pagination.totalItems) {
            this.pagination.page++;
        }
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("Add"),
                title: "Ajouter une note de frais",
                pages: [
                    {
                        text: "Suivez les instructions de créations de note de frais… ",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Search"),
                title: "Faites une recherche",
                pages: [
                    {
                        text: "Ou alors recherchez-en une déjà existante avec les filtres disponibles",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Interval"),
                title: "L'intervalle de prix",
                pages: [
                    {
                        text: "Rechercher des notes de frais dans un intervalle de prix",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Statut"),
                title: "Le statut de la note de frais",
                pages: [
                    {
                        text: "Vous retrouvez ici le statut de votre note de frais",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Date"),
                title: "La date des notes de frais",
                pages: [
                    {
                        text: "Choisissez une date",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Delete"),
                title: "Mise à jour",
                pages: [
                    {
                        text: "Vous retrouvez ici le statut de votre note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Details"),
                title: "Les détails d'une note de frais",
                pages: [
                    {
                        text: "Vous trouvez ici les détails d'une ou plusieurs note de frais",
                        position: "bottom",
                        align: "center",
                    },
                ],
            },
        ]);
    }
}

export default toNative(ExpenseReports);
</script>
